import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase'
import * as _ from 'lodash'
import VueMoment from 'vue-moment'

Vue.use(VueMoment)

import App from './App'
import router from '@/router'
import store from './store'

import Utils from './providers/Utils'

import {
    LayoutPlugin, NavbarPlugin, ButtonPlugin,
    FormPlugin, FormInputPlugin, FormSelectPlugin, FormGroupPlugin, FormTextareaPlugin, FormRadioPlugin,
    FormCheckboxPlugin, InputGroupPlugin,
    CollapsePlugin, CardPlugin, PopoverPlugin, TabsPlugin, AlertPlugin, BadgePlugin, ModalPlugin, ListGroupPlugin, SpinnerPlugin,

} from 'bootstrap-vue'

Vue.use(LayoutPlugin)
Vue.use(NavbarPlugin)
Vue.use(ButtonPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(InputGroupPlugin)
Vue.use(CollapsePlugin)
Vue.use(CardPlugin)
Vue.use(PopoverPlugin)
Vue.use(TabsPlugin)
Vue.use(AlertPlugin)
Vue.use(BadgePlugin)
Vue.use(ModalPlugin)
Vue.use(ListGroupPlugin)
Vue.use(SpinnerPlugin)

import HighchartsVue from 'highcharts-vue'

Vue.use(HighchartsVue)
import Highcharts from 'highcharts'

// import exporting from "highcharts/modules/exporting"
// exporting(Highcharts)

Vue.config.productionTip = false

Utils.registerComponents()
Utils.addCustomMixin('api')

import api from '@/providers/Api'

let app = null

const config = {
    apiKey: "AIzaSyCWL6MfNAEO8QcLGsxd0b6GpUFUf8TjxK8",
    authDomain: "interventioncentral-vue.firebaseapp.com",
    databaseURL: "https://interventioncentral-vue.firebaseio.com",
    projectId: "interventioncentral-vue",
    storageBucket: "interventioncentral-vue.appspot.com",
    messagingSenderId: "730013748100"
}

firebase.initializeApp(config)

// don't load main app until we have the firebase user (possibly null)
firebase.auth().onAuthStateChanged((fbUser) => {
    // console.log('initial fbUser', fbUser)
    if (!app) {
        app = new Vue({
            router,
            store,
            api,
            render: h => h(App),
        }).$mount('#app')
    }
});
